import { render, staticRenderFns } from "./WhatsappConsentModal.vue?vue&type=template&id=526071b6"
import script from "./WhatsappConsentModal.vue?vue&type=script&lang=js"
export * from "./WhatsappConsentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports